/*
  Koji: righe "Continua la saga" e "Edizioni speciali" complete.
  Liquid vede solo i primi 50 prodotti di una collezione; qui leggiamo TUTTA la collezione-saga
  da /collections/<handle>/products.json (a pagine da 250) e ricostruiamo le due righe.
  Se la lettura fallisce restano le righe gia' disegnate dal server (versione ridotta).
*/
(function () {
  'use strict';

  var PUNCT = ".,-–—:;!?()[]+&/'’#*_°º";
  var NOISE = ['vol', 'volume', 'n', 'no', 'ed', 'edizione', 'edition', 'numero', 'nr'];
  var CACHE_MS = 10 * 60 * 1000;
  var pending = {};

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  function norm(str) {
    var s = String(str || '').toLowerCase();
    var out = '';
    for (var i = 0; i < s.length; i++) {
      var c = s.charAt(i);
      out += (PUNCT.indexOf(c) > -1 || s.charCodeAt(i) === 34) ? ' ' : c;
    }
    return out.split(' ').filter(Boolean);
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* titolo -> {special, label, num, series}. Stessa regola di koji-edition-parse.liquid */
  function parse(title, kws, kwWords) {
    var tokens = norm(title);
    var padded = ' ' + tokens.join(' ') + ' ';
    var special = false;
    var label = '';
    var i;
    for (i = 0; i < kws.length; i++) {
      var kw = norm(kws[i]).join(' ');
      if (kw && padded.indexOf(' ' + kw + ' ') > -1) { special = true; label = kw; break; }
    }
    var kwIdx = 9999;
    if (special) {
      for (i = 0; i < tokens.length; i++) {
        if (kwWords.indexOf(tokens[i]) > -1) { kwIdx = i; break; }
      }
    }
    var before = null, beforeIdx = -1;
    var after = null, afterIdx = -1;
    for (i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      if (!/^[0-9]+$/.test(t)) continue;
      var n = parseInt(t, 10);
      if (n >= 1900 || (n === 0 && t !== '0')) continue;
      if (i < kwIdx) { before = n; beforeIdx = i; } else if (after === null) { after = n; afterIdx = i; }
    }
    var num = before !== null ? before : after;
    var numIdx = before !== null ? beforeIdx : afterIdx;
    var stop = Math.min(tokens.length, kwIdx, numIdx >= 0 ? numIdx : tokens.length);
    var series = [];
    for (i = 0; i < stop; i++) {
      if (NOISE.indexOf(tokens[i]) > -1 || kwWords.indexOf(tokens[i]) > -1) continue;
      series.push(tokens[i]);
    }
    return { special: special, label: label, num: num, series: series.join(' ') };
  }

  /* ordine: dal volume successivo a quello corrente in su, poi i precedenti, in fondo chi non ha numero */
  function arrange(list, curNum) {
    var numbered = list.filter(function (x) { return x.num !== null; });
    var plain = list.filter(function (x) { return x.num === null; });
    numbered.sort(function (a, b) { return a.num - b.num || (a.t < b.t ? -1 : a.t > b.t ? 1 : 0); });
    if (curNum === null) return numbered.concat(plain);
    var next = numbered.filter(function (x) { return x.num > curNum; });
    var prev = numbered.filter(function (x) { return x.num <= curNum; });
    return next.concat(prev, plain);
  }

  function money(n) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    if (cur === 'EUR') return '€' + n.toFixed(2).replace('.', ',');
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(n); }
    catch (e) { return n.toFixed(2); }
  }

  function slim(p) {
    var price = null;
    var avail = false;
    (p.variants || []).forEach(function (v) {
      var x = parseFloat(v.price);
      if (!isNaN(x) && (price === null || x < price)) price = x;
      if (v.available) avail = true;
    });
    var img = (p.images && p.images[0] && p.images[0].src) || (p.image && p.image.src) || '';
    return { h: p.handle, t: p.title || '', ty: String(p.product_type || '').toLowerCase(), img: img, a: avail, pr: price };
  }

  function loadAll(handle) {
    if (pending[handle]) return pending[handle];
    var key = 'kojiSaga:' + handle;
    try {
      var raw = sessionStorage.getItem(key);
      if (raw) {
        var o = JSON.parse(raw);
        if (o && Date.now() - o.t < CACHE_MS && o.items) { pending[handle] = Promise.resolve(o.items); return pending[handle]; }
      }
    } catch (e) { /* storage non disponibile: si legge ogni volta */ }

    pending[handle] = (async function () {
      var items = [];
      for (var page = 1; page <= 24; page++) {
        var res = await fetch(root() + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        var data = await res.json();
        var list = (data && data.products) || [];
        for (var i = 0; i < list.length; i++) items.push(slim(list[i]));
        if (list.length < 250) break;
      }
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), items: items })); } catch (e) { /* ok */ }
      return items;
    })();
    pending[handle].catch(function () { delete pending[handle]; });
    return pending[handle];
  }

  function cardHtml(p, label) {
    var src = '';
    if (p.img) src = p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    var html = '<li class="koji-volume-card' + (p.a ? '' : ' is-soldout') + '">' +
      '<a class="koji-volume-link" href="' + esc(root() + 'products/' + p.h) + '">' +
      '<div class="koji-volume-cover">';
    if (src) html += '<img src="' + esc(src) + '" alt="" width="400" height="600" loading="lazy" decoding="async">';
    if (!p.a) html += '<span class="koji-volume-tag">Esaurito</span>';
    if (label) html += '<span class="koji-volume-edition">' + esc(label.charAt(0).toUpperCase() + label.slice(1)) + '</span>';
    html += '</div><h3 class="koji-volume-name">' + esc(p.t) + '</h3>' +
      '<span class="koji-volume-price">' + (p.pr === null ? '' : esc(money(p.pr))) + '</span></a></li>';
    return html;
  }

  function rowHtml(opts) {
    var html = '<section class="koji-saga-volumes' + (opts.editions ? ' koji-saga-editions' : '') + '" aria-labelledby="' + opts.id + '">' +
      '<div class="koji-saga-volumes-head"><div>' +
      '<p class="koji-saga-volumes-eyebrow">' + esc(opts.eyebrow) + '</p>' +
      '<h2 class="koji-saga-volumes-title" id="' + opts.id + '">' + esc(opts.title) + '</h2></div>';
    if (opts.linkUrl) html += '<a class="koji-saga-volumes-all" href="' + esc(opts.linkUrl) + '">' + esc(opts.linkText) + ' →</a>';
    html += '</div><ul class="koji-saga-volumes-list">' + opts.cards.join('') + '</ul></section>';
    return html;
  }

  function build(box, items) {
    var d = box.dataset;
    var kws = (d.keywords || '').toLowerCase().split(',');
    var kwWords = [];
    kws.forEach(function (k) { kwWords = kwWords.concat(norm(k)); });

    var curHandle = d.currentHandle;
    var curType = (d.currentType || '').toLowerCase();
    var cur = parse(d.currentTitle, kws, kwWords);

    var parsed = [];
    items.forEach(function (p) {
      if (p.h === curHandle) return;
      var info = parse(p.t, kws, kwWords);
      parsed.push({ p: p, t: p.t, num: info.num, special: info.special, label: info.label, series: info.series });
    });

    var out = '';

    if (d.showVolumes === 'true') {
      var excl = d.excludeSpecial === 'true';
      var vols = parsed.filter(function (x) {
        return x.p.ty === curType && !(excl && x.special);
      });
      /* prima la stessa serie del prodotto (es. ONE PIECE), poi le altre linee della saga (ristampe, spin-off, ecc.) */
      var same = vols.filter(function (x) { return x.series === cur.series; });
      var other = vols.filter(function (x) { return x.series !== cur.series; });
      var vOrdered = arrange(same, cur.num).concat(arrange(other, null)).slice(0, parseInt(d.maxVolumes, 10) || 12);
      if (vOrdered.length) {
        out += rowHtml({
          id: 'koji-saga-volumes-title', eyebrow: d.sagaTitle, title: d.volumesTitle,
          linkUrl: d.sagaUrl, linkText: 'Vedi tutta la saga',
          cards: vOrdered.map(function (x) { return cardHtml(x.p, ''); })
        });
      }
    }

    if (d.showEditions === 'true') {
      var sp = parsed.filter(function (x) { return x.special && x.p.ty === curType; });
      var spA = arrange(sp.filter(function (x) { return x.p.a; }), cur.num);
      var spS = arrange(sp.filter(function (x) { return !x.p.a; }), cur.num);
      var eOrdered = spA.concat(spS).slice(0, parseInt(d.maxEditions, 10) || 30);
      if (eOrdered.length) {
        out += rowHtml({
          id: 'koji-saga-editions-title', editions: true, eyebrow: d.sagaTitle,
          title: cur.special ? d.editionsTitleAlt : d.editionsTitle,
          linkUrl: d.editionsUrl, linkText: 'Tutte le edizioni speciali',
          cards: eOrdered.map(function (x) { return cardHtml(x.p, x.label); })
        });
      }
    }
    return out;
  }

  function init(box) {
    var handle = box.dataset.sagaHandle;
    if (!handle) return;
    loadAll(handle).then(function (items) {
      box.innerHTML = build(box, items);
      box.setAttribute('data-ready', 'true');
    }).catch(function () {
      box.setAttribute('data-ready', 'fallback');
    });
  }

  function start() {
    var boxes = document.querySelectorAll('.koji-saga-live');
    for (var i = 0; i < boxes.length; i++) init(boxes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
